import React from 'react'

function Icon({active = '#202020'}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill={active}
        fillOpacity="0.5"
        d="M13.333 14.667H2.667A.667.667 0 012 14V2a.667.667 0 01.667-.667h10.666A.667.667 0 0114 2v12a.666.666 0 01-.667.667zm-.666-1.334V2.667H3.333v10.666h9.334zM5.333 6h5.334v1.333H5.333V6zm0 2.667h5.334V10H5.333V8.667z"
      ></path>
    </svg>
  )
}

export default Icon
